import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import BottomBox from 'src/components/BottomBox/BottomBox'
import ExpenseCategoriesInputs from 'src/components/ExpenseCategoriesInputs/ExpenseCategoriesInputs'
import { translateNode } from 'src/localization/translateNode'
import { ExpenseDetailsModel } from 'src/models/transaction.models'
import { css } from 'styled-components'

export enum ExpenseCategoriesContext {
  VIRTUAL_CARD = 'virtual_card',
  TRANSACTION = 'transaction',
}

interface ExpenseCategoriesInputBoxProps {
  className?: string
  context?: ExpenseCategoriesContext
  showUpdates?: boolean
  initialExpenseDetails?: Record<string, Array<ExpenseDetailsModel | undefined>>
  expenseDetails?: Record<string, string>
  expenseDetailsErrors?: Record<
    string,
    Array<React.ReactElement | string> | undefined
  >
  onExpenseDetailChange: (rfId: string, labelCode: string) => void
  deselectExpenseDetail: (rfId: string) => void
  isRequest?: boolean
  hasIntegrations?: boolean
  closedByDefault?: boolean
  isCardUpdateForm?: boolean
  requiresUpdateApproval?: boolean
  hideWasOnUpdate?: boolean
  explicitSelectNone?: boolean
  testId?: string
  testIdOptionBox?: string
}

const getUpdateExpenseCategoriesMessage = (
  hasIntegrations: boolean,
  requiresUpdateApproval: boolean,
): React.ReactElement => {
  if (hasIntegrations && requiresUpdateApproval) {
    return translateNode(
      'Updating expense categories on your virtual card will only apply to future transactions once your update request has been approved. To update historical transactions, please use the transaction bulk update.',
    )
  } else if (hasIntegrations && !requiresUpdateApproval) {
    return translateNode(
      'Updating expense categories on your virtual card will only apply to future transactions. To update historical transactions, please use the transaction bulk update.',
    )
  } else if (!hasIntegrations && requiresUpdateApproval) {
    return translateNode(
      'Updating expense categories on your virtual card will only apply to future transactions once your update request has been approved. To update historical transactions, please use the transaction bulk update.',
    )
  } else {
    // (!hasIntegrations && !requiresUpdateApproval)
    return translateNode(
      'Updating expense categories on your virtual card will only apply to future transactions. To update historical transactions, please use the transaction bulk update.',
    )
  }
}

const ExpenseCategoriesInputBox: React.FC<ExpenseCategoriesInputBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <BottomBox
      label={translateNode('Expense Categories')}
      collapsible
      testId={'expense-categories-box'}
      css={css`
        display: flex;
        flex-direction: column;
      `}
      closedByDefault={props.closedByDefault}
    >
      {props.isCardUpdateForm && (
        <div
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )}
            margin-bottom: 32px;
          `}
        >
          <span>
            {getUpdateExpenseCategoriesMessage(
              !!props.hasIntegrations,
              !!props.requiresUpdateApproval,
            )}
          </span>
        </div>
      )}
      <ExpenseCategoriesInputs
        context={props.context}
        showUpdates={props.showUpdates}
        initialExpDetailsMultiple={props.initialExpenseDetails}
        expenseDetails={props.expenseDetails}
        expenseDetailsErrors={props.expenseDetailsErrors}
        onExpenseCategoryChange={props.onExpenseDetailChange}
        deselectExpenseCategory={props.deselectExpenseDetail}
        hideWasOnUpdate={props.hideWasOnUpdate}
        explicitSelectNone={props.explicitSelectNone}
        enforceRequired={!props.isRequest}
        testId={props.testId}
        testIdOptionBox={props.testIdOptionBox}
      />
    </BottomBox>
  )
}

export default ExpenseCategoriesInputBox
